import React from 'react';
import { UseFormRegister } from 'react-hook-form';

import { clsx } from 'clsx';

import { ERROR_LABEL_ROLE } from '../../constants/testId';
import { FormValues } from './../../types';

import styles from './Input.scss';

type InputProps = {
  id: 'name' | 'phone' | 'email';
  placeholder: string;
  errorLabel?: string;
  register: UseFormRegister<FormValues>;
};

const Input = ({ id, placeholder, errorLabel, register, ...props }: InputProps) => (
  <div className={styles.inputWithError}>
    {errorLabel && (
      <label role={ERROR_LABEL_ROLE} htmlFor={id} className={styles.errorLabel}>
        {errorLabel}
      </label>
    )}
    <input
      {...props}
      className={clsx(styles.inputContainer, { [styles.inputContainerError]: errorLabel })}
      id={id}
      placeholder={placeholder}
      {...register(id)}
    />
  </div>
);

export default Input;
